import { render, staticRenderFns } from "./EmailDesigner.vue?vue&type=template&id=63704630&scoped=true&"
import script from "./EmailDesigner.vue?vue&type=script&lang=js&"
export * from "./EmailDesigner.vue?vue&type=script&lang=js&"
import style0 from "./EmailDesigner.vue?vue&type=style&index=0&id=63704630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63704630",
  null
  
)

export default component.exports